import React from 'react'
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import {
  mdiCursorDefault,
  mdiInvertColors,
  mdiEllipse,
  mdiAngleAcute,
  mdiCubeOutline,
  mdiInformationOutline,
} from '@mdi/js'

/**
 * Paleta flotante derecha (shell OHIF).
 */
function OhifFloatingPalette({
  anyOpen,
  toolActive,
  toolExecute,
  onMpr3d,
  onDoseInfo,
  mpr3dAllowed,
  visibleMpr3D,
}) {
  if (!anyOpen) return null
  const iconColor = 'var(--ohif-icon, #cbd5e1)'
  const accent = 'var(--ohif-accent, #3b82f6)'

  const btn = (title, path, onClick, active) => (
    <Tooltip title={title} placement="left" key={title}>
      <IconButton
        size="small"
        className={active ? 'udv-ohif-btn is-active' : 'udv-ohif-btn'}
        onClick={onClick}
        aria-label={title}
      >
        <Icon path={path} size={0.78} color={active ? accent : iconColor} />
      </IconButton>
    </Tooltip>
  )

  return (
    <div className="udv-ohif-floating" aria-label="Herramientas rápidas">
      {btn('No Tool', mdiCursorDefault, () => toolExecute && toolExecute('notool'), toolActive === 'notool')}
      {btn('Invertir', mdiInvertColors, () => toolExecute && toolExecute('Invert'), toolActive === 'Invert')}
      {btn('Elliptical ROI', mdiEllipse, () => toolExecute && toolExecute('EllipticalRoi'), toolActive === 'EllipticalRoi')}
      {btn('Angle', mdiAngleAcute, () => toolExecute && toolExecute('Angle'), toolActive === 'Angle')}
      {btn(
        visibleMpr3D ? 'Volver a MPR' : '3D',
        mdiCubeOutline,
        () => onMpr3d && onMpr3d(),
        !!visibleMpr3D
      )}
      {btn('Dosis', mdiInformationOutline, () => onDoseInfo && onDoseInfo(), false)}
    </div>
  )
}

export default OhifFloatingPalette
